import Headroom from 'headroom.js';

class HeaderAnimation {
  // 1. describe and create/initiate our object
  constructor() {
    this.headerElement = document.getElementById('site-header');
    this.bodyElement = document.getElementById('app');

    this.headroom = new Headroom(this.headerElement, {
      'offset': 150,
      'tolerance': 2,
      'classes': {
        'initial': 'animated',
        'pinned': 'slideDown',
        'unpinned': 'slideUp',
      },
    });
  }
  events() {
    this.headroom.init()

    this.adjustHeight()

    window.onresize = () => {
      this.adjustHeight()
    };
  }
  adjustHeight() {
    this.bodyElement.style.paddingTop = this.headerElement.offsetHeight + 'px'
  }
}
export default HeaderAnimation;
